import {Component, Input, OnInit} from '@angular/core';
import {CommunicationProxyService} from '../../services/communication-proxy.service';
import {CommunicationSubjectEnum} from '../../enum/communication-subject-enum';
import {ManagerFiltersControls, ManagerFilterType} from '../../../home/manager-filters/manager-filters.component';

@Component({
  selector: 'app-buttons-filters',
  templateUrl: './buttons-filters.component.html',
  styleUrls: ['./buttons-filters.component.scss']
})
export class ButtonsFiltersComponent implements OnInit {

  @Input() icon: string;
  @Input() maxWidth = false;
  @Input() isDisabled = false;
  @Input() isActive = false;
  @Input() type: ManagerFilterType;

  constructor(private communicationProxyService: CommunicationProxyService) { }

  ngOnInit(): void {
    this.communicationProxyService
        .subscribe(CommunicationSubjectEnum.onManagerFiltersUpdated, (message: any) => {
          return this.setActiveFilter(message.message);
    });
  }

  setActiveFilter(filtersControls: ManagerFiltersControls) {
    if (filtersControls && filtersControls.type === this.type) {
      return this.isActive = true;
    }
    this.isActive = false;
  }

}
